<template>
	<slot
		:values="value"
		:errors="errors"
		:error-message="errorMessage"
		:toggle="toggle"
		:is-checked="isChecked"
	></slot>
</template>

<script setup>
import { computed } from 'vue'
import { useField } from 'vee-validate'
import * as yup from 'yup'

const props = defineProps({
	name: String,
	validatorString: String
})

const validator = computed(() => {
	if (!props.validatorString) return undefined
	return new Function('yup', `return ${props.validatorString}`)(yup)
})

const { value, errors, handleChange } = useField(() => props.name, validator, {
	initialValue: []
})

const toggle = (item) => {
	const arr = Array.isArray(value.value) ? [...value.value] : []
	const idx = arr.indexOf(item)
	if (idx > -1) {
		arr.splice(idx, 1)
	} else {
		arr.push(item)
	}
	handleChange(arr, true)
}

const isChecked = (item) => {
	return Array.isArray(value.value) && value.value.includes(item)
}

const errorMessage = computed(() => {
	return errors.value.length > 0 ? errors.value.map(s => s.charAt(0).toUpperCase() + s.slice(1)).join('. ') + '.' : ''
})
</script>
